export function XrayMailDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.MAIL)
        .setCustomActions({
            'get': {
                method: 'GET'
            },
            'update': {
                method: 'PUT'
            },
            'test': {
                method: 'POST',
                path: XRAY_RESOURCE.MAIL + '/test',
                notifications: true
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/mail_dao.js